(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/create-wager/assets/bet/board-numboards.js') >= 0) return;  svs.modules.push('/components/payment/create-wager/assets/bet/board-numboards.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const BoardPoolgames = svs.components.payment.createWager.bet.BoardPoolgames;
const SystemType = svs.components.payment.common.constants.SystemType;
const calculateMsystem = svs.components.tipsen.expandedSystems.utils.calculateMsystem;
const getMaltipsetRSystem = svs.components.sport.systems.getMaltipsetRSystem;
const WagerError = svs.components.payment.common.error.WagerError;
const asStringArray = array => "".concat(array.join(','));
class BoardNumboards extends BoardPoolgames {
  addOutcomes(outcomes) {
    if (!Array.isArray(outcomes)) {
      throw new WagerError({
        message: 'outcomes has to be an array',
        clientCode: WagerError.ErrorCodes.GENERIC
      });
    }
    const _outcomes = [...new Set(outcomes)];
    const _this$productConfig$e = _slicedToArray(this.productConfig.eventBounds, 2),
      min = _this$productConfig$e[0],
      max = _this$productConfig$e[1];
    if (_outcomes.length < min || _outcomes.length > max) {
      const rem = outcomes.length - _outcomes.length;
      let message = "".concat(min, " to ").concat(max, " outcomes is required. \"").concat(_outcomes, "\"");
      if (rem > 0) {
        message += ", ".concat(rem, " duplicates removed.");
      }
      message += " (length: ".concat(_outcomes.length, ") is not valid.");
      throw new WagerError({
        message,
        clientCode: WagerError.ErrorCodes.GENERIC
      });
    }
    _outcomes.forEach(selection => super.addOutcomes([selection]));
    return this;
  }

  getBoardData() {
    return this.outcomes.map(selection => {
      const newSelection = [...selection[0]];
      return newSelection[0];
    });
  }

  getRowCount() {
    const numSelections = this.getBoardData().length;
    switch (this.systemType) {
      case SystemType.MSYS:
        return calculateMsystem(numSelections);
      case SystemType.RSYS:
        return getMaltipsetRSystem(numSelections);
      default:
        return super.getRowCount();
    }
  }

  setSystemNumber(systemNumber) {
    if (!getMaltipsetRSystem(systemNumber)) {
      throw new WagerError({
        message: "Unsupported systemNumber: ".concat(systemNumber),
        clientCode: WagerError.ErrorCodes.UNSUPPORTED_VALUE_SYSTEM_NUMBER
      });
    }
    super.setSystemNumber(systemNumber);
    return this;
  }

  get systemType() {
    const numSelections = this.getBoardData().length;
    const _this$productConfig$e2 = _slicedToArray(this.productConfig.eventBounds, 2),
      min = _this$productConfig$e2[0],
      max = _this$productConfig$e2[1];
    if (numSelections > min && numSelections <= max) {
      if (!this.systemNumber) {
        return SystemType.MSYS;
      }
      if (this.systemNumber) {
        return SystemType.RSYS;
      }
    }
    return super.systemType;
  }

  composeOwnRows() {
    const outcomeString = this.outcomes.map(signArray => signArray.map(sign => {
      if (sign < 10) {
        return "0".concat(sign);
      }
      return "".concat(sign);
    })).join('');
    return outcomeString;
  }

  compose() {
    const boardData = this.getBoardData();
    const isSystem = this.systemType === SystemType.MSYS || this.systemType === SystemType.RSYS;
    return {
      rowPriceMulti: 1,
      boardData,
      numSelections: this.outcomes.length,
      participation: '0',
      systemNum: isSystem ? this.outcomes.length : 0,
      boardProps: this.boardProperties,
      systemType: [this.systemType]
    };
  }

  toString() {
    const logString = super.toString();
    const outcomeString = this.outcomes.map(board => board.map(selection => asStringArray(selection))).join(',');
    const logEntries = ["B:[".concat(outcomeString, "]"), logString];
    return logEntries.join(' ');
  }
}
setGlobal('svs.components.payment.createWager.bet.BoardNumboards', BoardNumboards);

 })(window);